/**
 * La photo de profil prête à partir, au web. La galerie du navigateur rend la photo entière : celle
 * d'un téléphone pèse 3 à 12 Mo, et le serveur la refuse (413, « Changer ma photo » ne marchait pas,
 * Wajih, 03/11 — l'ancien écran passait par son recadreur, qui rendait une petite image). On la
 * recadre donc ici au carré central, à `AVATAR_MAX_SIDE` au plus, en JPEG : quelques centaines de
 * Ko, et la même forme que la photo recadrée du téléphone.
 *
 * Une image que le navigateur ne sait pas décoder (un HEIC sous Chrome) lève : l'appelant le dit.
 */
import { avatarCrop } from "./avatarImageGeometry"
import { drawJpeg, loadImage } from "./canvasJpeg.web"
import { type AvatarImage, type PreparedAvatarImage } from "./avatarImage"

export type { AvatarImage, PreparedAvatarImage } from "./avatarImage"

const JPEG_QUALITY = 0.88

export async function prepareAvatarImage(image: AvatarImage): Promise<PreparedAvatarImage> {
    const source = await loadImage(image.uri)
    const { sx, sy, side, target } = avatarCrop(source.naturalWidth, source.naturalHeight)
    const { uri, dispose } = await drawJpeg(
        source,
        { x: sx, y: sy, width: side, height: side },
        { width: target, height: target },
        JPEG_QUALITY
    )
    return { uri, mimeType: "image/jpeg", dispose }
}
